import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { getStatsForVehiclesView } from "../../services/vehicle";
import { useTheme } from '@mui/material/styles';
import { useQuery } from "react-query";
import InfoTile from "../common/InfoTile";

const VehicleStats = () => {
  const theme = useTheme();
  const { data } = useQuery(
    "getStatsForVehiclesView",
    getStatsForVehiclesView,
    {
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      suspense: true,
    }
  );
  return (
    <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
      <Grid size={{ xs: 2, sm: 2, md: 3 }}>
        <InfoTile
          title={"Visteon Provisioned"}
          info={data?.visteonProvisioned}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 3 }}>
        <InfoTile
          title={"Customer Provisioned"}
          info={data?.customerProvisioned}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 3 }}>
        <Card variant="outlined" sx={{ padding: "2%" }}>
          <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}> 
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <CardContent className="tile-cards">
                <Typography color="text.secondary">
                  Active vehicles
                </Typography>
                <Typography
                  color={theme.palette.primary['A700']}
                  sx={{ fontSize: 40, fontWeight: 500, marginTop: '2%' }}
                >
                  {data?.activeVehicles}
                </Typography>
              </CardContent>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <CardContent className="tile-cards">
                <Typography color="text.secondary">
                  Inactive vehicles
                </Typography>
                <Typography
                  color={theme.palette.primary['A700']}
                  sx={{ fontSize: 40, fontWeight: 500, marginTop: '2%' }}
                >
                  {data?.inActiveVehicles}
                </Typography>
              </CardContent>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 3 }}>
        <InfoTile
          title={"Subscriptions (Vehicles)"}
          info={data?.vehiclesWithActiveSubscriptions}
        />
      </Grid>
    </Grid>
  );
};

export default VehicleStats;
